import { useNavigate } from "react-router";

import PersonIcon from "@mui/icons-material/Person";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { useAuth } from "../AuthContext";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useGetCurrentUserQuery } from "../../user/userApiSlice";

const SignOut = () => {
	const { t } = useTranslation();
	const { data: user, error, isLoading } = useGetCurrentUserQuery();

	const navigate = useNavigate();
	const { signOut, isSigningOut } = useAuth();

	const handleLogout = async () => {
		try {
			await signOut();
			setTimeout(() => {
				navigate("/login");
			}, 300);
		} catch (err) {
			console.log("Sign Out - Error:", err);
		}
	};

	if (isLoading) {
		return <CircularProgress size={16} />;
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "end",
				justifyContent: "center",
			}}
		>
			<Box
				sx={{ display: "flex", alignItems: "center", gap: "4px", pr: "3px" }}
			>
				<PersonIcon sx={{ color: "#A6A6A6", fontSize: "14px" }} />
				<Typography sx={{ color: "#A6A6A6", fontSize: "12px" }}>
					{user?.first_name} {user?.last_name}
				</Typography>
			</Box>
			<Button
				sx={{ color: "#0070C0", pr: 0, py: 0 }}
				loading={isSigningOut}
				variant="text"
				onClick={handleLogout}
			>
				{t("sign_out")}
			</Button>
		</Box>
	);
};

export default SignOut;
